import { Route, Routes as BrowserRoutes } from "react-router"
import Invoices from "./invoices"
import NewInvoice from "./invoices/new"
import ProvisionalInvoice from "./invoices/provisional"
import InvoiceDetail from "./invoices/detail"
import Movements from "./movements"
import Losses from "./losses"
import Traceability from "./traceability"
import Inventory from "./inventory"
import Conference from "./conference"
import Adjustments from "./adjustments"
import Alerts from "./alerts"
import Reconciliation from "./reconciliation"
import Transfers from "./transfers"

export default function Stock() {
    return (
        <BrowserRoutes>
            <Route path="/invoices"               element={<Invoices />} />
            <Route path="/invoices/new"           element={<NewInvoice />} />
            <Route path="/invoices/provisional"   element={<ProvisionalInvoice />} />
            <Route path="/invoices/:id"           element={<InvoiceDetail />} />
            <Route path="/movements"              element={<Movements />} />
            <Route path="/losses"                 element={<Losses />} />
            <Route path="/traceability"           element={<Traceability />} />
            <Route path="/inventory"              element={<Inventory />} />
            <Route path="/conference"             element={<Conference />} />
            <Route path="/adjustments"            element={<Adjustments />} />
            <Route path="/alerts"                 element={<Alerts />} />
            <Route path="/reconciliation"         element={<Reconciliation />} />
            <Route path="/transfers"              element={<Transfers />} />
        </BrowserRoutes>
    )
}
